import { useState } from 'react';
import '../../components/app/DemandedJobs.scss'


const Form = ({ formData, dynamic = false, onSubmit, render, handleInputChange = undefined, className = '' }) => {
    const [data, setData] = useState(formData);
    const getData = () => {
        return dynamic ? formData : data;
    }
    const handleFormChange = (event) => {
        let fData = (handleInputChange ? handleInputChange(event, getData()) : getFieldValue(event));
        setData({ ...fData });
    }
    const getFieldValue = (e) => {
        const { name, value, checked } = e?.target;
        getData()[name] = e.target.type === 'checkbox' ? checked : value;
        return {
            ...getData()
        };
    }
    const handleFormSubmit = (event) => {
        event.preventDefault();
        onSubmit(event, getData());
    }
    return (
        <form className={className} onSubmit={handleFormSubmit}>
            {
                render(getData(), handleFormChange)
            }
        </form>
    );
}

export default Form;